/* eslint-disable no-unused-vars */
import React from 'react';
import { Container } from 'react-bootstrap';
import { FiGlobe, FiShield, FiFileText } from 'react-icons/fi';
import VisaSearchForm from '../../components/VisaSearchForm/VisaSearchForm';
import { DEFAULT_NATIONALITY } from '../../constants/onlineVisaConstants';
import './OnlineVisaLandingPage.scss';

const FEATURES = [
  {
    icon: <FiGlobe />,
    title: 'Live Intelligence',
    description: 'Real-time protocol updates from 150+ global embassies.',
  },
  {
    icon: <FiShield />,
    title: 'Error-Shield',
    description: 'Automated compliance checks to guarantee 1st-time approval.',
  },
  {
    icon: <FiFileText />,
    title: 'One-Click Quotes',
    description: 'Instantly generate branded visa proposals for your clients.',
  },
];

/**
 * Decorative V monogram used on the right side of the hero card.
 * Matches the Figma illustration — two chevron-like panels, one deep blue, one
 * teal, overlapping at the base of the V.
 */
function HeroIllustration() {
  return (
    <svg
      className="online-visa-landing__illustration"
      viewBox="0 0 520 520"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="ovLeftStroke" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#1f2dcb" />
          <stop offset="100%" stopColor="#2a69e6" />
        </linearGradient>
        <linearGradient id="ovRightStroke" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#26d69b" />
          <stop offset="100%" stopColor="#1fb7c9" />
        </linearGradient>
      </defs>
      {/* Left wing of the V */}
      <polygon
        points="30,40 140,40 320,460 230,460"
        fill="url(#ovLeftStroke)"
      />
      {/* Right wing of the V */}
      <polygon
        points="490,40 380,40 230,460 320,460"
        fill="url(#ovRightStroke)"
      />
    </svg>
  );
}

function OnlineVisaLandingPage() {
  return (
    <main className="online-visa-landing">
      {/* HERO with gradient card */}
      <section className="online-visa-landing__hero-section">
        <Container>
          <div className="online-visa-landing__hero-card">
            <div className="online-visa-landing__search">
              <VisaSearchForm
                initialValues={{
                  nationality: DEFAULT_NATIONALITY.countryCode,
                }}
              />
            </div>
            {/* <div className="online-visa-landing__art">
              <HeroIllustration />
            </div> */}
          </div>
        </Container>
      </section>

      {/* FEATURES STRIP */}
      <section className="online-visa-landing__features">
        <Container>
          <div className="online-visa-landing__features-row">
            {FEATURES.map((f, idx) => (
              <div
                key={f.title}
                className={`feature-item ${
                  idx > 0 ? 'feature-item--bordered' : ''
                }`}
              >
                <div className="feature-item__icon">{f.icon}</div>
                <div className="feature-item__text">
                  <h3 className="feature-item__title">{f.title}</h3>
                  <p className="feature-item__description">{f.description}</p>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </main>
  );
}

export default OnlineVisaLandingPage;
